export const addKeys = (ele: (JSX.Element | undefined)[]) =>
  ele?.map(
    (e, index) => ({ ...e, key: `${index}-column` } as JSX.Element),
  );
